import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card, Button, Modal, Form, CardGroup } from 'react-bootstrap';
import { Tabs, TabsHeader, TabsBody, Tab, TabPanel } from "@material-tailwind/react";
import { firestore } from '../Firebase/Firebase'; // Import Firestore from your Firebase.js
import { collection, onSnapshot } from 'firebase/firestore';
import { auth } from '../Firebase/Firebase'; // Import your Firebase configuration
import { onAuthStateChanged } from 'firebase/auth'
import { gsap } from 'gsap';
import "./Store.scss"
import styles from "./ImageGrid2.module.css"
import { motion } from "framer-motion";
import { GoHeart } from "react-icons/go";
import { BiSolidCartDownload } from "react-icons/bi";
import { getStorage, ref, getMetadata } from 'firebase/storage';
import StoreImgSkeleton from './skeletons/StoreImgSkeleton';
import SignIn from '../SignIn.js';
import SignUp from '../SignUp.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



function MyVerticallyCenteredModal(props) {
    const styles = {
        backgroundColor: "#F0F0F0",
        borderRadius: "5px"
    }

    const HeadStyle = {
        backgroundColor: "#F0F0F0",
    }


    // State to track the current mode (sign-in or sign-up)
    const [mode, setMode] = useState('signin');

    // Function to switch between sign-in and sign-up modes
    const handleSetMode = (mode) => {
        setMode(mode);
    };
    return (
        <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton style={HeadStyle}></Modal.Header>
            <Modal.Body style={styles}>
                <div className="d-flex justify-content-center alignos ">
                    <button className="btn btn-link" onClick={() => handleSetMode('signin')}>
                        Sign In
                    </button>
                    <span className="mx-2">|</span>
                    <button className="btn btn-link" onClick={() => handleSetMode('signup')}>
                        Sign Up
                    </button>
                </div>
                {mode === 'signin' ? (
                    <SignIn handleclosemodal={props.handleclosemodal} notifylogin={props.notifylogin} />
                ) : (
                    <SignUp handleclosemodal={props.handleclosemodal} notifylogin={props.notifylogin} />
                )}

            </Modal.Body>
        </Modal>
    );
}


function WelcomeAssets() {

    const [assets, setAssets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [uniqueLabels, setUniqueLabels] = useState([]);
    const [activeTab, setActiveTab] = useState('all');
    const [user, setUser] = useState(null);
    const postsPerPageWithImages = 6;
    const [imagesLoaded, setImagesLoaded] = useState(0);
    const [filteredAssets, setFilteredAssets] = useState([]);

    const [likeCounts, setLikeCounts] = useState({});


    // const { currentUser } = useAuth();
    const [modalShow, setModalShow] = useState(false);

    const handleclosemodal = () => {
        setModalShow(false);
    };
    const handleShowModal = () => {
        setModalShow(true);
    };


    useEffect(() => {
        let ctx = gsap.context(() => {
            gsap.to(".App", { duration: .0, css: { visibility: 'visible' } });
        });
        return () => {
            ctx.revert();
        }
    }, []);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setUser(user); // Set the authenticated user
        });

        return () => unsubscribe(); // Cleanup the listener on unmount
    }, []);

    const getFileType = (url) => {
        // Extract the file extension from the URL
        const extensionMatch = url.match(/\.([a-zA-Z0-9]+)(\?.*)?$/);
        const extension = extensionMatch ? extensionMatch[1].toLowerCase() : '';

        switch (extension) {
            case 'pdf':
                return 'PDF Document';
            case 'jpg':
            case 'jpeg':
            case 'png':
                return 'Image';
            case 'mp3':
                return 'Audio';
            case 'mp4':
                return 'Video';
            case 'zip':
                return 'ZIP Archive';
            case 'psd':
                return 'PSD';
            case 'blend':
                return 'BLEND';
            case 'blend1':
                return 'BLEND';
            case 'prproj':
                return 'Premiere Pro';
            case 'aep':
                return 'After Effects';
            case 'abr':
                return 'Photoshop Brush';
            // Add more cases as needed
            default:
                return 'Unknown File Type';
        }
    };


    // Convert bytes to a readable format
    const formatFileSize = (bytes) => {
        if (bytes === null) return 'N/A';
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
    };

      const notifyUnSuccess = () => {
        toast.error('You must be logged in to like an asset.', {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    useEffect(() => {
        const fetchAssets = async () => {
            const assetsCollection = collection(firestore, 'Assets');
            const unsubscribe = onSnapshot(assetsCollection, async (snapshot) => {
                const assetsList = await Promise.all(
                    snapshot.docs.map(async (doc) => {
                        const data = { id: doc.id, ...doc.data() };

                        // Get the file type based on the asset URL
                        data.fileType = getFileType(data.asset);
                        setLikeCounts(prev => ({ ...prev, [data.id]: data.likes || 0 }));

                        // Get file size from Firebase Storage
                        const storage = getStorage();
                        const assetRef = ref(storage, data.asset);  // Assuming `data.asset` is the path in Firebase Storage

                        try {
                            const metadata = await getMetadata(assetRef);
                            data.fileSize = metadata.size; // File size in bytes
                        } catch (error) {
                            console.error("Error fetching file metadata:", error);
                            data.fileSize = null; // If there's an error fetching the file size, set it to null
                        }

                        return data;
                    })
                );

                setAssets(assetsList);
                setFilteredAssets(assetsList);

                // Extract unique categories
                const originalLabels = Array.from(new Set(
                    assetsList.map(doc => doc.category).filter(Boolean)
                ));

                // Prepare display labels mapping
                const displayLabels = originalLabels.map(label => ({
                    original: label,
                    display: label.endsWith('s') ? label : `${label}s`
                }));

                setUniqueLabels(displayLabels);
                setLoading(false); // Set loading to false after fetching
            }, (error) => {
                console.error("Error fetching assets:", error);
                setError(error.message);
                setLoading(false); // Set loading to false on error
            });

            return () => unsubscribe(); // Cleanup the listener on unmount
        };

        fetchAssets();
    }, []);

    const handleTabClick = (tab) => {

        let filtered;

        switch (tab) {
            case 'free':
                filtered = assets.filter(asset => asset.price === "free");
                break;
            case '1000-10000':
                filtered = assets.filter(asset => {
                    const price = parseInt(asset.price, 10);
                    return price >= 1000 && price <= 10000;
                });
                break;
            case '20000-30000':
                filtered = assets.filter(asset => {
                    const price = parseInt(asset.price, 10);
                    return price >= 20000 && price <= 30000;
                });
                break;
            case '30000+':
                filtered = assets.filter(asset => {
                    const price = parseInt(asset.price, 10);
                    return price >= 30000;
                });
                break;
            default:
                filtered = assets; // Show all assets
                break;
        }

        setFilteredAssets(filtered);
        setActiveTab(tab);
    };


    const handleImageLoad = () => {
        setImagesLoaded(prev => prev + 1); // Increment loaded images count
    };

    // Check if all images are loaded
    const allImagesLoaded = imagesLoaded === assets.length;

    const getDocumentCountByLabel = (displayLabel) => {
        const mapping = uniqueLabels.find(item => item.display === displayLabel);
        if (!mapping) return 0; // If mapping is missing, return 0
        const originalLabel = mapping.original;
        return assets.filter(asset => asset.category === originalLabel).length;
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedAsset(null);
    };

    // Count the number of free assets
    const freeAssetCount = assets.filter(asset => asset.price === "free").length;

    const toggleLike = async () => {
        if (!user) {
            notifyUnSuccess();
            return;
        }
    }


  

    // Simulate loading completion after 5 seconds for demonstration
    useEffect(() => {
        const loadingCompleteTimer = setTimeout(() => {
            setLoading(false); // Set loading to false after 5 seconds
        }, 5000); // Change this duration as needed

        return () => clearTimeout(loadingCompleteTimer);
    }, []);

    const count1000To10000 = assets.filter(asset => {
        const price = parseInt(asset.price, 10);
        return price >= 1000 && price <= 10000;
    }).length;
    const count20000To30000 = assets.filter(asset => {
        const price = parseInt(asset.price, 10);
        return price >= 20000 && price <= 30000;
    }).length;
    const count30000Plus = assets.filter(asset => {
        const price = parseInt(asset.price, 10);
        return price >= 30000;
    }).length;

    if (loading) return <Container > <Row xs={1} md={3} xl={3}>
        {[...Array(postsPerPageWithImages)].map((_, index) => (
            <Col key={`skeleton_${index}`} className='col-sm'>
                <StoreImgSkeleton />
            </Col>
        ))}
    </Row></Container>;
    if (error) return <p>Error fetching assets: {error}</p>;


    return (

        <>
            <MyVerticallyCenteredModal
                show={modalShow}
                // handleShowModal={handleShowModal}
                onHide={handleclosemodal}
                // Pass handleclosemodal function to MyVerticallyCenteredModal
                handleclosemodal={handleclosemodal}
            />
            <Container >

                <section className={styles['cutscene']}>

                </section>
                <ToastContainer className="toastContainer" />

                <div className={styles["portfo"]}>
                    <Tabs value={activeTab} className={styles['tabiu_store']} >
                        <TabsHeader
                            className={styles['tabHeader']}


                        >
                            <Tab
                                title={`All (${assets.length})`}
                                value="all"
                                onClick={() => handleTabClick('all')}
                                className={`${styles['filters']} ${activeTab === 'all' ? styles.activeTab : ''}`}
                            >
                                <span> All</span>
                                <span className={styles['count']}>{assets.length}</span>
                            </Tab>
                            <Tab
                                value="free"
                                onClick={() => handleTabClick('free')}
                                className={`${styles['filters']} ${activeTab === 'free' ? styles.activeTab : ''}`}
                            >
                                <span>Free</span>
                                <span className={styles['count']}>{freeAssetCount}</span>
                            </Tab>
                            <Tab
                                value="1000-10000"
                                onClick={() => handleTabClick('1000-10000')}
                                className={`${styles['filters']} ${activeTab === '1000-10000' ? styles.activeTab : ''}`}
                            >
                                <span>₦1,000 - ₦10,000</span>
                                <span className={styles['count']}>{count1000To10000}</span>
                            </Tab>
                            <Tab
                                value="20000-30000"
                                onClick={() => handleTabClick('20000-30000')}
                                className={`${styles['filters']} ${activeTab === '20000-30000' ? styles.activeTab : ''}`}
                            >
                                <span>₦20,000 - ₦30,000</span>
                                <span className={styles['count']}>{count20000To30000}</span>
                            </Tab>
                            <Tab
                                value="30000+"
                                onClick={() => handleTabClick('30000+')}
                                className={`${styles['filters']} ${activeTab === '30000+' ? styles.activeTab : ''}`}
                            >
                                <span>₦30,000+</span>
                                <span className={styles['count']}>{count30000Plus}</span>
                            </Tab>

                            {uniqueLabels.map(({ display }) => (
                                <Tab
                                    title={`${display} (${getDocumentCountByLabel(display)})`}
                                    key={display}
                                    value={display}
                                    onClick={() => handleTabClick(display)}
                                    className={`${styles['filters']} ${activeTab === display ? styles.activeTab : ''}`}
                                >
                                    <span>{display}</span>
                                    <span className={styles['count']}>{getDocumentCountByLabel(display)}</span>
                                </Tab>
                            ))}
                        </TabsHeader>

                        <TabsBody
                            animate={{
                                initial: { y: 250 },
                                mount: { y: 0 },
                                unmount: { y: 250 },
                            }}
                            className={styles['tabsBod']}
                        >
                            {loading || allImagesLoaded ? (
                                <TabPanel value="all">
                                    <Row xs={1} md={3} xl={3}>
                                        {[...Array(postsPerPageWithImages)].map((_, index) => (
                                            <Col key={`skeleton_${index}`} className='col-sm'>
                                                <StoreImgSkeleton />
                                            </Col>
                                        ))}
                                    </Row>
                                </TabPanel>
                            ) : (
                                <TabPanel value="all" className={styles['surround_store']} >
                                    <Container className='fluidContain'>



                                        {filteredAssets.length > 0 ? (
                                            filteredAssets.map((asset, index) => (
                                                <div className={styles["packs"]} key={asset.id || index}>
                                                    <Row className='assety'>
                                                        <Col >

                                                            <CardGroup className="card-wrapper">

                                                                <motion.div
                                                                    className={'assetCard'}

                                                                    whileHover={{ top: "-10px", scale: 1.01 }}
                                                                    transition={{ type: "tween", stiffness: 300 }}
                                                                    layout
                                                                >

                                                                    {asset.category === 'Video Template' ? (
                                                                        <>
                                                                            <div className="cart-placement">


                                                                                <video width="100%" height="auto" autoPlay loop muted poster={asset.thumbnail} className='imageImg'>
                                                                                    <source src={asset.thumbnail} type={'video/mp4'} />
                                                                                    Your browser does not support the video tag.
                                                                                </video>
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <div className="cart-placement">

                                                                                <div className="placeholder" id='placeholder'></div>

                                                                                <Card.Img variant="top" src={asset.thumbnail}
                                                                                    alt="Thumbnail"
                                                                                    className='imageImg'
                                                                                    style={{
                                                                                        width: loading ? '400px' : '100%',
                                                                                        height: loading ? '300px' : '100%',
                                                                                        display: loading ? 'block' : 'flex', // Hide the image while loading
                                                                                        objectFit: 'cover', // Adjust as needed
                                                                                    }}
                                                                                    onLoad={handleImageLoad} />
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                    <Card.Body className='assetCardBody'>
                                                                        <Card.Title className='assetCardHead'>{asset.name}</Card.Title>
                                                                        <Card.Text className='assetCardText'>Price: {asset.price === "free" ? "Free" : `₦${new Intl.NumberFormat("en-NG").format(asset.price)}`}</Card.Text>

                                                                        <div className="line"><div className="line-inner"></div></div>
                                                                        <div className="bottom-area">
                                                                            <Button
                                                                                variant="primary"
                                                                                className='learnBtn'
                                                                                onClick={handleShowModal}
                                                                            >
                                                                                SignIn
                                                                            </Button>

                                                                            <div className="downs">


                                                                                <p className='carty'><BiSolidCartDownload className='heart-here' /> <strong>{asset.downloads || 0}</strong></p>


                                                                                <div className="likes">


                                                                                    <div className="heart" onClick={() => toggleLike(asset.id)}>
                                                                                        <GoHeart className='heart-here' />
                                                                                    </div>

                                                                                    {/* Display Like Count */}
                                                                                    <p style={{ color: '#121212' }} className='numb-like' onClick={() => toggleLike(asset.id)}>
                                                                                        {likeCounts[asset.id] || 0}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Card.Body>

                                                                </motion.div>
                                                            </CardGroup>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            ))
                                        ) : (
                                            <p>No assets available.</p>
                                        )}


                                    </Container>
                                </TabPanel>
                            )}
                            {uniqueLabels.map(({ original, display }) => (
                                <TabPanel key={original} value={display} className={styles['surround']}>
                                    <Container>
                                        {filteredAssets.filter(doc => doc.category === original).map((asset, index) => (
                                            <div className={styles["packs"]} key={asset.id || index}>
                                                <Row className='assety'>
                                                    <Col>
                                                        <CardGroup className={styles["cardhi"]}>
                                                            <motion.div
                                                                className={'assetCard'}
                                                                whileHover={{ top: "-10px", scale: 1.01 }}
                                                                layout
                                                            >
                                                                {asset.category === 'Video Template' ? (
                                                                    <>
                                                                        <div className="cart-placement">


                                                                            <video width="100%" height="auto" autoPlay loop muted poster={asset.thumbnail} className='imageImg'>
                                                                                <source src={asset.thumbnail} type={'video/mp4'} />
                                                                                Your browser does not support the video tag.
                                                                            </video>
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div className="cart-placement">


                                                                            <Card.Img variant="top" src={asset.thumbnail}
                                                                                alt="Thumbnail"
                                                                                className='imageImg'
                                                                                onLoad={handleImageLoad} />
                                                                        </div>
                                                                    </>
                                                                )}
                                                                <Card.Body className='assetCardBody'>
                                                                    <Card.Title className='assetCardHead'>{asset.name}</Card.Title>
                                                                    <Card.Text className='assetCardText'>Price: {asset.price === "free" ? "Free" : `₦${new Intl.NumberFormat("en-NG").format(asset.price)}`}</Card.Text>
                                                                    <div className="line"><div className="line-inner"></div></div>
                                                                    <div className="bottom-area">
                                                                        <Button
                                                                            variant="primary"
                                                                            className='learnBtn'
                                                                            onClick={handleShowModal}
                                                                        >
                                                                            SignIn
                                                                        </Button>

                                                                        <div className="downs">
                                                                            <p className='carty'><BiSolidCartDownload className='heart-here' /> <strong>{asset.downloads || 0}</strong></p>


                                                                            <div className="likes">

                                                                                <div className="heart" onClick={() => toggleLike(asset.id)}>
                                                                                    <GoHeart className='heart-here' />
                                                                                </div>

                                                                                {/* Display Like Count */}
                                                                                <p style={{ color: '#121212' }} className='numb-like' onClick={() => toggleLike(asset.id)}>
                                                                                    {likeCounts[asset.id] || 0}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Card.Body>
                                                            </motion.div>
                                                        </CardGroup>
                                                    </Col>
                                                </Row>
                                            </div>
                                        ))}
                                    </Container>
                                </TabPanel>
                            ))}

                            <TabPanel value="free" className={styles['surround']}>
                                <Container>
                                    {filteredAssets.filter(asset => asset.price === "free").map((asset) => (
                                        <div className={styles["packs"]} key={asset.id}>
                                            <Row className='assety'>
                                                <Col>
                                                    <CardGroup className={styles["cardhi"]}>
                                                        <motion.div
                                                            className={'assetCard'}
                                                            whileHover={{ top: "-10px", scale: 1.01 }}
                                                            layout
                                                        >
                                                            {asset.category === 'Video Template' ? (
                                                                <>
                                                                    <div className="cart-placement">

                                                                        <video width="100%" height="auto" autoPlay loop muted poster={asset.thumbnail} className='imageImg'>
                                                                            <source src={asset.thumbnail} type={'video/mp4'} />
                                                                            Your browser does not support the video tag.
                                                                        </video>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="cart-placement">

                                                                        <Card.Img variant="top" src={asset.thumbnail}
                                                                            alt="Thumbnail"
                                                                            className='imageImg'
                                                                            onLoad={handleImageLoad} />
                                                                    </div>
                                                                </>
                                                            )}
                                                            <Card.Body className='assetCardBody'>
                                                                <Card.Title className='assetCardHead'>{asset.name}</Card.Title>
                                                                <Card.Text className='assetCardText'>Price: {asset.price === "free" ? "Free" : `₦${new Intl.NumberFormat("en-NG").format(asset.price)}`}</Card.Text>
                                                                <div className="line"><div className="line-inner"></div></div>
                                                                <div className="bottom-area">
                                                                    <Button
                                                                        variant="primary"
                                                                        className='learnBtn'
                                                                        onClick={handleShowModal}
                                                                    >
                                                                        SignIn
                                                                    </Button>

                                                                    <div className="downs">
                                                                        <p className='carty'><BiSolidCartDownload className='heart-here' /> <strong>{asset.downloads || 0}</strong></p>


                                                                        <div className="likes">

                                                                            <div className="heart" onClick={() => toggleLike(asset.id)}>
                                                                                <GoHeart className='heart-here' />
                                                                            </div>

                                                                            {/* Display Like Count */}
                                                                            <p style={{ color: '#121212' }} className='numb-like' onClick={() => toggleLike(asset.id)}>
                                                                                {likeCounts[asset.id] || 0}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Card.Body>
                                                        </motion.div>
                                                    </CardGroup>
                                                </Col>
                                            </Row>
                                        </div>
                                    ))}
                                </Container>
                            </TabPanel>
                            <TabPanel value="1000-10000" className={styles['surround']}>
                                <Container>
                                    {filteredAssets.filter(asset => {
                                        const price = parseInt(asset.price, 10);
                                        return price >= 1000 && price <= 10000;
                                    }).map((asset) => (
                                        <div className={styles["packs"]} key={asset.id}>
                                            <Row className='assety'>
                                                <Col>
                                                    <CardGroup className={styles["cardhi"]}>
                                                        <motion.div
                                                            className={'assetCard'}
                                                            whileHover={{ top: "-10px", scale: 1.01 }}
                                                            layout
                                                        >
                                                            {asset.category === 'Video Template' ? (
                                                                <>
                                                                    <div className="cart-placement">


                                                                        <video width="100%" height="auto" autoPlay loop muted poster={asset.thumbnail} className='imageImg'>
                                                                            <source src={asset.thumbnail} type={'video/mp4'} />
                                                                            Your browser does not support the video tag.
                                                                        </video>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="cart-placement">

                                                                        <Card.Img variant="top" src={asset.thumbnail}
                                                                            alt="Thumbnail"
                                                                            className='imageImg'
                                                                            onLoad={handleImageLoad} />
                                                                    </div>
                                                                </>
                                                            )}
                                                            <Card.Body className='assetCardBody'>
                                                                <Card.Title className='assetCardHead'>{asset.name}</Card.Title>
                                                                <Card.Text className='assetCardText'>Price: {asset.price === "free" ? "Free" : `₦${new Intl.NumberFormat("en-NG").format(asset.price)}`}</Card.Text>
                                                                <div className="line"><div className="line-inner"></div></div>
                                                                <div className="bottom-area">
                                                                    <Button
                                                                        variant="primary"
                                                                        className='learnBtn'
                                                                        onClick={handleShowModal}
                                                                    >
                                                                        SignIn
                                                                    </Button>

                                                                    <div className="downs">
                                                                        <p className='carty'><BiSolidCartDownload className='heart-here' /> <strong>{asset.downloads || 0}</strong></p>


                                                                        <div className="likes">

                                                                            <div className="heart" onClick={() => toggleLike(asset.id)}>
                                                                                <GoHeart className='heart-here' />
                                                                            </div>

                                                                            {/* Display Like Count */}
                                                                            <p style={{ color: '#121212' }} className='numb-like' onClick={() => toggleLike(asset.id)}>
                                                                                {likeCounts[asset.id] || 0}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Card.Body>
                                                        </motion.div>
                                                    </CardGroup>
                                                </Col>
                                            </Row>
                                        </div>
                                    ))}
                                </Container>
                            </TabPanel>

                            <TabPanel value="20000-30000" className={styles['surround']}>
                                <Container>
                                    {filteredAssets.filter(asset => {
                                        const price = parseInt(asset.price, 10);
                                        return price >= 20000 && price <= 30000;
                                    }).map((asset) => (
                                        <div className={styles["packs"]} key={asset.id}>
                                            <Row className='assety'>
                                                <Col>
                                                    <CardGroup className={styles["cardhi"]}>
                                                        <motion.div
                                                            className={'assetCard'}
                                                            whileHover={{ top: "-10px", scale: 1.01 }}
                                                            layout
                                                        >
                                                            {asset.category === 'Video Template' ? (
                                                                <>
                                                                    <div className="cart-placement">


                                                                        <video width="100%" height="auto" autoPlay loop muted poster={asset.thumbnail} className='imageImg'>
                                                                            <source src={asset.thumbnail} type={'video/mp4'} />
                                                                            Your browser does not support the video tag.
                                                                        </video>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="cart-placement">


                                                                        <Card.Img variant="top" src={asset.thumbnail}
                                                                            alt="Thumbnail"
                                                                            className='imageImg'
                                                                            onLoad={handleImageLoad} />
                                                                    </div>
                                                                </>
                                                            )}
                                                            <Card.Body className='assetCardBody'>
                                                                <Card.Title className='assetCardHead'>{asset.name}</Card.Title>
                                                                <Card.Text className='assetCardText'>Price: {asset.price === "free" ? "Free" : `₦${new Intl.NumberFormat("en-NG").format(asset.price)}`}</Card.Text>
                                                                <div className="line"><div className="line-inner"></div></div>
                                                                <div className="bottom-area">
                                                                    <Button
                                                                        variant="primary"
                                                                        className='learnBtn'
                                                                        onClick={handleShowModal}
                                                                    >
                                                                        SignIn
                                                                    </Button>

                                                                    <div className="downs">
                                                                        <p className='carty'><BiSolidCartDownload className='heart-here' /> <strong>{asset.downloads || 0}</strong></p>


                                                                        <div className="likes">

                                                                            <div className="heart" onClick={() => toggleLike(asset.id)}>
                                                                                <GoHeart className='heart-here' />
                                                                            </div>

                                                                            {/* Display Like Count */}
                                                                            <p style={{ color: '#121212' }} className='numb-like' onClick={() => toggleLike(asset.id)}>
                                                                                {likeCounts[asset.id] || 0}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Card.Body>
                                                        </motion.div>
                                                    </CardGroup>
                                                </Col>
                                            </Row>
                                        </div>
                                    ))}
                                </Container>
                            </TabPanel>

                            <TabPanel value="30000+" className={styles['surround']}>
                                <Container>
                                    {filteredAssets.filter(asset => {
                                        const price = parseInt(asset.price, 10);
                                        return price >= 30000;
                                    }).map((asset) => (
                                        <div className={styles["packs"]} key={asset.id}>
                                            <Row className='assety'>
                                                <Col>
                                                    <CardGroup className={styles["cardhi"]}>
                                                        <motion.div
                                                            className={'assetCard'}
                                                            whileHover={{ top: "-10px", scale: 1.01 }}
                                                            layout
                                                        >
                                                            {asset.category === 'Video Template' ? (
                                                                <>
                                                                    <div className="cart-placement">


                                                                        <video width="100%" height="auto" autoPlay loop muted poster={asset.thumbnail} className='imageImg'>
                                                                            <source src={asset.thumbnail} type={'video/mp4'} />
                                                                            Your browser does not support the video tag.
                                                                        </video>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="cart-placement">


                                                                        <Card.Img variant="top" src={asset.thumbnail}
                                                                            alt="Thumbnail"
                                                                            className='imageImg'
                                                                            onLoad={handleImageLoad} />
                                                                    </div>
                                                                </>
                                                            )}
                                                            <Card.Body className='assetCardBody'>
                                                                <Card.Title className='assetCardHead'>{asset.name}</Card.Title>
                                                                <Card.Text className='assetCardText'>Price: {asset.price === "free" ? "Free" : `₦${new Intl.NumberFormat("en-NG").format(asset.price)}`}</Card.Text>
                                                                <div className="line"><div className="line-inner"></div></div>
                                                                <div className="bottom-area">
                                                                    <Button
                                                                        variant="primary"
                                                                        className='learnBtn'
                                                                        onClick={handleShowModal}
                                                                    >
                                                                        SignIn
                                                                    </Button>

                                                                    <div className="downs">
                                                                        <p className='carty'><BiSolidCartDownload className='heart-here' /> <strong>{asset.downloads || 0}</strong></p>


                                                                        <div className="likes">

                                                                            <div className="heart" onClick={() => toggleLike(asset.id)}>
                                                                                <GoHeart className='heart-here' />
                                                                            </div>

                                                                            {/* Display Like Count */}
                                                                            <p style={{ color: '#121212' }} className='numb-like' onClick={() => toggleLike(asset.id)}>
                                                                                {likeCounts[asset.id] || 0}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Card.Body>
                                                        </motion.div>
                                                    </CardGroup>
                                                </Col>
                                            </Row>
                                        </div>
                                    ))}
                                </Container>
                            </TabPanel>


                        </TabsBody>
                    </Tabs>
                </div>

                {/* Modal for Purchase Confirmation */}
                <Modal show={showModal} onHide={handleCloseModal} className='purch-mod' centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Purchase Asset</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h5>{selectedAsset?.name}</h5>
                        <p>{selectedAsset?.fileType} </p>
                        <p>Price: <strong>{selectedAsset?.price === "free" ? "Free" : `₦${new Intl.NumberFormat("en-NG").format(selectedAsset?.price)}`}</strong></p>
                        {selectedAsset?.fileSize && (
                            <p>File Size: <strong>{formatFileSize(selectedAsset.fileSize)}</strong></p>  // Use a helper function to format the size
                        )}
                        {selectedAsset?.price !== "free" && (
                            <Form>


                                <p>Click the button below to proceed with the payment.</p>
                            </Form>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" className='redBtn' onClick={handleCloseModal}>
                            Close
                        </Button>

                        <Button variant="primary" className='learnBtn' >
                            Purchase Asset
                        </Button>

                    </Modal.Footer>
                </Modal>

        
            </Container>
        </>
    )
}

export default WelcomeAssets
